import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';


const AnimatedSearch = () => {
  const [query, setQuery] = useState('');
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
    setQuery('');
  };

  return (
    <form
      ref={containerRef}
      onSubmit={handleSubmit}
      className="relative flex flex-row-reverse items-center w-full"
    >
      <button
        type="submit"
        className="p-2 rounded-lg hover:bg-gray-800 transition-colors focus-ring"
      >
        <FaSearch className="w-5 h-5 text-white" />
      </button>
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search..."
        className="bg-gray-800 border border-gray-700 text-white rounded-md ml-2 px-3 py-2 flex-grow min-w-0 md:flex-grow-0 md:w-64"
      />
    </form>
  );
};

export default AnimatedSearch;
